import React, {useMemo} from "react";
import {CreditsListsOrdersDataGridCellKeys} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import {DataGridColumnAlignments, DataGridColumnTypes, useDataGridSavedState} from "../../../../../../../../../packages/data-grid";
import IconButton from "../../../../../../../../components/base/button/icon_button";
import {OpenInNew} from "@mui/icons-material";
import PartnerDataGrid from "../../../../../../../../containers/data-grid";
import {CircularProgress, SvgIcon} from "@mui/material";
import useAccessLevels from "../../../../../../../../hooks/use-access-levels";
import {ReactComponent as Printer} from '../../../../../../../../../assets/images/printer.svg'

const CreditsListViewOrdersTable = ({
                                        searchData,
                                        exportToCsv,
                                        data,
                                        dataGridSaveConfig,
                                        navigateToInformationView,
                                        navigateToPrintView,
                                        fetchingOrdersCustomer,
                                    }) => {
    const operatorAccessLevels = useAccessLevels();


    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            ...(operatorAccessLevels.packages.sales.creditInformation ? [
                {
                    name: CreditsListsOrdersDataGridCellKeys.navigate,
                    alignment: DataGridColumnAlignments.center,
                    type: DataGridColumnTypes.element,
                    pinned: true,
                    sortable: false,
                    pinnedToggleable: false,
                    resizable: false,
                    visibilityToggleable: false,
                    width: 0,
                },
                ...(operatorAccessLevels.packages.bizPrint.printCredit ? [
                    {
                        name: CreditsListsOrdersDataGridCellKeys.print,
                        alignment: DataGridColumnAlignments.center,
                        type: DataGridColumnTypes.element,
                        pinned: true,
                        sortable: false,
                        pinnedToggleable: false,
                        resizable: false,
                        visibilityToggleable: false,
                        width: 0,
                    },
                ] : []),
            ] : []),
            {
                title: "Invoice No",
                name: CreditsListsOrdersDataGridCellKeys.invoiceNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                pinned: true,
            },
            {
                title: "Customer",
                name: CreditsListsOrdersDataGridCellKeys.customer,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Invoice Date",
                name: CreditsListsOrdersDataGridCellKeys.invoiceDate,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.date,
            },
            {
                title: "Customer PO",
                name: CreditsListsOrdersDataGridCellKeys.customerPO,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Sales Person",
                name: CreditsListsOrdersDataGridCellKeys.salespersonNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Total Ordered",
                name: CreditsListsOrdersDataGridCellKeys.totalOrdered,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
                width: 120,
            },
        ], [operatorAccessLevels.packages.bizPrint.printCredit, operatorAccessLevels.packages.sales.creditInformation])

    const [dataGridColumns, , , dataGridDensity] = useDataGridSavedState({
        columns: columns,
        version: dataGridSaveConfig.version,
        name: dataGridSaveConfig.name,
    });


    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return data?.map(order => ({
            key: order.id,
            data: order,
            cells: {
                [CreditsListsOrdersDataGridCellKeys.navigate]:
                    <IconButton
                        color={'secondary'}
                        disabled={fetchingOrdersCustomer.includes(order.id)}
                        onClick={() => navigateToInformationView(order.customer, order.id)}

                    >
                        {
                            fetchingOrdersCustomer.includes(order.id)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <OpenInNew className='icon normal'/>
                        }
                    </IconButton>,
                [CreditsListsOrdersDataGridCellKeys.print]:
                    <IconButton
                        color={'paper.secondary'}
                        disabled={fetchingOrdersCustomer.includes(order.id)}
                        onClick={() => navigateToPrintView(order.customer, order.id)}
                    >
                        {
                            fetchingOrdersCustomer.includes(order.id)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <SvgIcon className='icon medium' component={Printer}/>
                        }

                    </IconButton>,
                [CreditsListsOrdersDataGridCellKeys.invoiceNo]: order.invoiceNo,
                [CreditsListsOrdersDataGridCellKeys.customer]: order.customer?.name,
                [CreditsListsOrdersDataGridCellKeys.invoiceDate]: order.invoiceDate,
                [CreditsListsOrdersDataGridCellKeys.customerPO]: order.customerPO,
                [CreditsListsOrdersDataGridCellKeys.salespersonNo]: order.salespersonNo,
                [CreditsListsOrdersDataGridCellKeys.totalOrdered]: order.total,
            }
        }))
    }, [data, fetchingOrdersCustomer, navigateToInformationView, navigateToPrintView])

    return (
        <>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                columns={dataGridColumns}
                rows={dataGridRows}
                state={{
                    pagination: searchData.paginationInfo,
                    sortBy: searchData.orderBy,
                    loading: {state: searchData.loading},
                    density: dataGridDensity,
                }}
                hideFooterActions
                getExportInfo={exportToCsv}
                onSortByChanged={(_, current) => searchData.setOrderBy(current)}
                onCurrentPageChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
                onPageSizeChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
            />
        </>
    );
}

export default CreditsListViewOrdersTable;
